const translations = {
  "en": {
    "Buy Signals %{var0}": "Buy Signals %{var0}",
    "Neutral Signals %{var0}": "Neutral Signals %{var0}",
    "Sell Signals %{var0}": "Sell Signals %{var0}"
  },
  "zh-tw": {
    "Buy Signals %{var0}": "買入訊號 %{var0}",
    "Neutral Signals %{var0}": "中性訊號 %{var0}",
    "Sell Signals %{var0}": "賣出訊號 %{var0}"
  }
};

export default translations;
